/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 21:35:58
 * @LastEditTime: 2021-11-15 16:30:29
 * @LastEditors: lkz
 */
/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'
import link from '../../../../utils/link/link'

// /***
//  * 校验是否存在未关闭售后单
//  * **/
export function createRefundCheck(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.GET('/refundadmin/butian/refund/createRefundCheck.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/refund/createRefundCheck.json`, params, options)
}
/*
* 查询售后商品集合
*/
export function returndetailBtJson(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/xinyun/refund/returndetailBtJson.json', params, options)
}
/*
* 根据TU获取TU的SKU集合
*/
export function getTUItemByTU(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/xinyun/compensate/getTUItemByTU.json', params, options)
}
// /***
//  * 售后申请页面金额、类型、数量
//  * **/
export function toRefundCommonView(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/butian/refund/v3/toRefundCommonView.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/toRefundCommonView.json`, params, options)
}

// /***
//  * 售后提交申请
//  * **/
export function refundCommonApply(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/butian/refund/v3/refundCommonApply.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/refundCommonApply.json`, params, options)
}

// /***
//  * 根据扣减金额、数量查询
//  * **/
export function getRefundCommonViewMoney(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/butian/refund/v3/getRefundCommonViewMoney.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/getRefundCommonViewMoney.json`, params, options)
}

// /***
//  * 省市区查询接口
//  * **/
export function getAddress(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.GET('/refundadmin/butian/refund/getCascadeAddress.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/refund/getCascadeAddress.json`, params, options)
}

/**
 * 查询售后是否超期
 */
export function afterSaleIsMoreThanAllowApplyTime(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.GET('/refundadmin/admin/v3/afterSaleIsMoreThanAllowApplyTime.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/admin/v3/afterSaleIsMoreThanAllowApplyTime.json`, params, options)
  // return httpAgent.GET(`//${link.getlink().refundUrl}/admin/v3/afterSaleIsMoreThanAllowApplyTime`, params, options)
}


/**
 * 售后申请自动填充
 */
export function getRefundApplyAutoFillPage(params, options) {
  // return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/getRefundApplyAutoFillPage`, params, options)
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/butian/refund/v3/getRefundApplyAutoFillPage', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/getRefundApplyAutoFillPage`, params, options)
}
